export const Branding = {
    Roomex: 'roomex',
    CorpayLodging: 'corpaylodging',    
  } as const;
  
  export type Branding = (typeof Branding)[keyof typeof Branding];  